var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3328 4.66667H0.666178C0.297512 4.66667 -0.000488281 4.96467 -0.000488281 5.33333V7.33333C-0.000488281 11.0093 2.99018 14 6.66618 14C9.39351 14 11.7408 12.3513 12.7722 10H13.9995C15.1022 10 15.9995 9.10267 15.9995 8V5.33333C15.9995 4.96467 15.7015 4.66667 15.3328 4.66667ZM14.6662 8C14.6662 8.368 14.3675 8.66667 13.9995 8.66667H13.1982C13.2862 8.236 13.3328 7.79 13.3328 7.33333V6H14.6662V8Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6662 14.6667H0.666178C0.297512 14.6667 -0.000488281 14.9647 -0.000488281 15.3333C-0.000488281 15.702 0.297512 16 0.666178 16H12.6662C13.0348 16 13.3328 15.702 13.3328 15.3333C13.3328 14.9647 13.0348 14.6667 12.6662 14.6667Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99951 0.666667H2.66618V3.33333H3.99951V0.666667Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33285 0H5.99951V2.66667H7.33285V0Z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6662 0.666667H9.33285V3.33333H10.6662V0.666667Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.448fa866.svg";
export { ForwardRef as ReactComponent };